/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAwsWorkspace extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAwsWorkspace");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAwsWorkspace.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAwsWorkspace>): BackgroundJobPayloadForPeriodicAwsWorkspace {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAwsWorkspace(), model);
        BackgroundJobPayloadForPeriodicAwsWorkspace.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAwsWorkspace>): BackgroundJobPayloadForPeriodicAwsWorkspace {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAwsWorkspace.newInstance(<BackgroundJobPayloadForPeriodicAwsWorkspace> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAwsWorkspace) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAwsWorkspace.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAwsWorkspace): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAwsWorkspace.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
